import { Result } from '../../index';

// Types
import { RateLimitsState, RateLimits, RateLimitType } from '../types/rate-limits';

const INITIAL_STATE = {};

enum RateLimitsActionTypes {
  Set = 'connect/rate-limits/set',
  Consume = 'connect/rate-limits/consume',
  Increment = 'connect/rate-limits/increment',
}

// Action Types
type SetAction = {
  type: RateLimitsActionTypes.Set;
  rates?: RateLimits;
};

type ConsumeAction = {
  type: RateLimitsActionTypes.Consume;
  limitType: RateLimitType;
  count: number;
};

type IncrementAction = {
  type: RateLimitsActionTypes.Increment;
  limitType: RateLimitType;
  count: number;
};

type RateLimitsAction = SetAction | ConsumeAction | IncrementAction;

// Reducer
export default function reducer(state: RateLimitsState = INITIAL_STATE, action: RateLimitsAction): RateLimitsState {
  switch (action.type) {
    case RateLimitsActionTypes.Set: {
      return action.rates || {};
    }
    case RateLimitsActionTypes.Consume: {
      const limit = state && state[action.limitType];

      if (!limit) {
        return state;
      }

      return {
        ...state,
        [action.limitType]: {
          ...state[action.limitType],
          remaining: (limit.remaining || 0) - action.count,
        },
      };
    }
    case RateLimitsActionTypes.Increment: {
      const limit = state && state[action.limitType];

      if (!limit) {
        return state;
      }

      return {
        ...state,
        [action.limitType]: {
          ...state[action.limitType],
          remaining: (limit.remaining || 0) + action.count,
        },
      };
    }
    default: {
      return state;
    }
  }
}

// Action Creators
export const setRateLimits =
  (rates?: RateLimits): Result<void> =>
  dispatch => {
    dispatch({ type: RateLimitsActionTypes.Set, rates } as SetAction);
  };

export const consumeLimit =
  (limitType: RateLimitType, count: number = 1): Result<void> =>
  dispatch => {
    dispatch({ type: RateLimitsActionTypes.Consume, limitType, count } as ConsumeAction);
  };

export const incrementLimit =
  (limitType: RateLimitType, count: number = 1): Result<void> =>
  dispatch => {
    dispatch({ type: RateLimitsActionTypes.Increment, limitType, count } as IncrementAction);
  };
